const axios = require("axios");

function getHeaders() {
  return { "Content-Type": "application/json" };

  // return {
  //   "Content-Type": "multipart/form-data",
  //   'Accept': "application/json",
  //   'type': "formData",
  // };
}
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  // timeout: 1000,
  headers: getHeaders(),
});

instance.interceptors.request.use((config) => {
  // 🔥 Show loader for ALL API requests
  const loader = document.getElementById("loading");
  if (loader) {
    loader.style.display = "flex";
  }

  // 🔐 Add auth token if exists
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  return config;
});

instance.interceptors.response.use(
  function (response) {
    // ✅ Hide loader when response is successful
    const loader = document.getElementById("loading");
    if (loader) {
      loader.style.display = "none";
    }
    return response;
  },
  function (error) {
    // ❌ Hide loader on error
    const loader = document.getElementById("loading");
    if (loader) {
      loader.style.display = "none";
    }

    // 🔐 Handle unauthorized or forbidden errors
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("uniqueId");
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

function apiGet(url, params = {}) {
  return instance.get(url, { params });
}

function apiPost(url, body) {
  return instance.post(url, body);
}

function apiPut(url, body) {
  return instance.put(url, body);
}

function apiDelete(url) {
  return instance.delete(url);
}

export { getHeaders, apiGet, apiPost, apiPut, apiDelete };
